<template>
  <!-- 見積一括選択 -->
  <div id="QuotationBulkSelectModal" style="width: 100%;height:100%;margin-top:1%;">
    <div class="modal-card" style="width: 100%;height:100%;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">{{title}}</p>
      </header>
      <section class="modal-card-body">
        <span v-if="topMsg" style="color:red;">{{topMsg}}</span>
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr class="quotation-select-table-top-header">
              <th style="width:10%;">見積検索</th>
              <th style="width:40%;">品目</th>
              <th style="width:40%;">見積番号</th>
              <!-- <th style="width:20%;">見積詳細番号</th> -->
              <th style="width:10%;text-align:center;">出荷指示</th>
              <!-- <th style="width:10%;text-align:center;">回収指示</th> -->
            </tr>
            <template v-for="(directionsItem,directionsItemIndex) in filteredDirectionsItemList">
              <tr :key="directionsItemIndex">
                <td>
                  <span style="display:inline-block; text-align:center; width:100%;"><b-checkbox v-model="directionsItem.isChecked"></b-checkbox></span>
                </td>
                <td>
                  <span v-if="directionsItem.itemCode">{{directionsItem.itemCode}}</span>
                  <span v-else style="color:red;">指示書未選択</span>
                  ：{{directionsItem.name}}
                </td>
                <td>
                  <span v-if="directionsItem.estimateCode">{{directionsItem.estimateCode}}</span>
                  <span v-else style="color:red;">見積未選択</span>
                </td>
                <!-- <td>
                  <span v-if="directionsItem.quotationDetailsNumber">{{directionsItem.quotationDetailsNumber}}</span>
                  <span v-else style="color:red;">見積未選択</span>
                </td> -->
                <td>
                  <span style="display:inline-block; text-align:center; width:100%;"><b-checkbox disabled v-model="directionsItem.shippingInstructionsFlg"></b-checkbox></span>
                </td>
                <!-- <td>
                  <span style="display:inline-block; text-align:center; width:100%;"><b-checkbox disabled v-model="directionsItem.collectionInstructionsFlg"></b-checkbox></span>
                </td> -->
              </tr>
            </template>
          </table>
          <div class="searchButton-area" style="margin-bottom:10px;text-align: center;">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area" v-if="data.length>0">
          <b-button class="is-primary" style="float: left;" @click="ShowDetail4Quotation">申込み内容参照</b-button>
          <b-table
            id="quotationSelectTable"
            class="quotation-select-btable-header"
            :data="data"
            paginated
            detailed
            :opened-detailed="detailOpenList"
            :has-detailed-visible="returnFalse"
            per-page="20"
            pagination-position="both"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            v-bind:key="renderKey"
            default-sort="quotationNumber"
            default-sort-direction="desc"
          >
            <template slot-scope="props">
              <b-table-column field="customerId" label="" width="20" centered>
                <b-radio class="customRadio" v-model="selectedItem" :native-value="props.row" @input="selecteRadio(props.row)"></b-radio>
              </b-table-column>
              <b-table-column width="150" centered>
                <span v-if="isSelected(props.row.index)" style="color:red; font-size:12px;">選択中の品目あり</span>
              </b-table-column>
              <b-table-column field="quotationNumber" label="見積番号" width="300" sortable>{{props.row.quotationNumber}}</b-table-column>
              <b-table-column field="billingDestinationCode" label="請求先コード" width="300" sortable>{{props.row.billingDestinationCode}}</b-table-column>
              <b-table-column field="billingDestinationName" label="請求先名" width="700" sortable>{{props.row.billingDestinationName}}</b-table-column>
              <b-table-column field="hospitalCode" label="医療機関コード" width="300" sortable>{{props.row.hospitalCode}}</b-table-column>
              <b-table-column field="hospitalName" label="医療機関名" width="650" sortable>{{props.row.hospitalName}}</b-table-column>
              <!-- <b-table-column field="estimatedDate" label="見積日" width="300" sortable>{{changeDate(props.row.estimatedDate)}}</b-table-column> -->
              <!-- <b-table-column field="salesOfficeCode" label="営業所コード" width="300" sortable>{{props.row.salesOfficeCode}}</b-table-column> -->
              <b-table-column field="salesOfficeName" label="営業所名" width="650" sortable>{{props.row.salesOfficeName}}</b-table-column>
              <!-- <b-table-column field="salespersonCode" label="営業員コード" width="300" sortable>{{props.row.salespersonCode}}</b-table-column> -->
              <b-table-column field="salespersonName" label="営業員名" width="650" sortable>{{props.row.salespersonName}}</b-table-column>
              <!-- <b-table-column field="priceApprovalNumber" label="価格稟議番号" width="300" sortable>{{props.row.priceApprovalNumber}}</b-table-column> -->
            </template>
            <template slot="detail" slot-scope="props">
              <!-- トグル下の詳細 -->
              <span v-for="(item,index) in props.row.items" v-bind:key="index">
                <div class="content">
                  <table class="quotationTable" style="table-layout: fixed;">
                    <tr v-if="index==0" class="quotation-select-table-detail-header" style="width:100%;">
                      <td style="width:100px;font-weight:bold;"/>
                      <!-- <td style="width:250px;font-weight:bold;">見積明細番号</td> -->
                      <td style="width:250px;font-weight:bold;">品目コード</td>
                      <td style="width:250px;font-weight:bold;">品目名</td>
                      <td style="width:150px;font-weight:bold;"></td>
                      <!-- <td style="width:80px;font-weight:bold;">数量</td> -->
                      <!-- <td style="width:80px;font-weight:bold;">単位</td> -->
                      <td style="width:100px;font-weight:bold;">納入価</td>
                      <!-- <td style="width:100px;font-weight:bold;">単価</td> -->
                      <!-- <td style="width:100px;font-weight:bold;">金額</td> -->
                      <td style="width:100%;font-weight:bold;">最終オーダー登録日</td>
                    </tr>
                    <tr v-if="!item.standardItems || item.standardItems.length==0">
                      <td checked="checked" style="width:100px;">
                        <b-checkbox value="ture" v-model="selectedItemDetail" :native-value="props.row.index+','+item.quotationDetailsNumber"/>
                      </td>
                      <!-- <td style="width:250px;">{{item.quotationDetailsNumber}}</td> -->
                      <td style="width:250px;">{{item.itemCode}}</td>
                      <td style="width:250px;">{{item.itemName}}</td>
                      <td style="width:150px;"></td>
                      <!-- <td style="width:80px;">{{item.quantity}}</td> -->
                      <!-- <td style="width:80px;">{{item.unit}}</td> -->
                      <td style="width:100px;">{{item.deliveryPrice}}</td>
                      <!-- <td style="width:100px;">{{item.unitPrice}}</td> -->
                      <!-- <td style="width:100px;">{{item.quotationPrice}}</td> -->
                      <td>{{changeDate(item.latestOrderRegisteredDate)}}</td>
                    </tr>
                    <!-- 標準品目の場合 -->
                    <template v-if="item.standardItems&&item.standardItems.length>0">
                      <td style="width:100px;">
                        <b-checkbox v-model="selectedItemDetail" :native-value="props.row.index+','+item.quotationDetailsNumber" disabled/>
                      </td>
                      <!-- <td style="width:250px;">
                        <span style="font-size:15px;">{{item.quotationDetailsNumber}}</span>
                      </td> -->
                      <td style="width:250px;">
                        <span style="font-size:15px;">{{item.itemCode}}</span>
                      </td>
                      <td style="width:250px;">
                        <span style="font-size:15px;">{{item.itemName}}</span>
                      </td>
                      <td style="width:150px;">
                        <span><b-button class="is-primary" style="width:100px; margin-left:10px;height:30px;" @click="standardItemSelect(item.itemCode,item.standardItems,props.row.quotationNumber,item.quotationDetailsNumber)">品目選択</b-button></span>
                      </td>
                      <!-- <td style="width:80px;">
                        <span style="font-size:15px;">{{item.quantity}}</span>
                      </td> -->
                      <!-- <td style="width:80px;">
                        <span style="font-size:15px;">{{item.unit}}</span>
                      </td> -->
                      <td style="width:100px;">
                        <span style="font-size:15px;">{{item.deliveryPrice}}</span>
                      </td>
                      <!-- <td style="width:100px;">
                        <span style="font-size:15px;">{{item.unitPrice}}</span>
                      </td> -->
                      <!-- <td style="width:100px;">
                        <span style="font-size:15px;">{{item.quotationPrice}}</span>
                      </td> -->
                      <td>
                        <span style="font-size:15px;">{{changeDate(item.latestOrderRegisteredDate)}}</span>
                      </td>
                      <tr>
                        <td :colspan="11" style="padding-right:0px;">
                          <!-- 選択した標準品目 -->
                          <span v-for="(standard,subIndex) in item.selectItems" v-bind:key="subIndex">
                          <div class="content">
                            <table style="table-layout: fixed;">
                              <!-- <tr v-if="subIndex==0" style="background-color: #cfdbea;">
                                <th style="width:25px;"/>
                                <th style="width:65px;"/>
                                <td style="width:250px;">品目コード</td>
                                <td>品目名</td>
                              </tr> -->
                              <tr class="quotation-select-table-standard-detail">
                                <td style="width:25px;"/>
                                <td style="width:65px;vertical-align: middle;">
                                  <b-checkbox style="width:15px;" v-model="selectedStandardItemDetail" :native-value="props.row.index+','+item.quotationDetailsNumber+','+standard.itemCode" @input="changeStandardItem(item.quotationDetailsNumber,props.row.index+','+item.quotationDetailsNumber)"/>
                                </td>
                                <td style="width:250px;">{{standard.itemCode}}</td>
                                <td>{{standard.itemName}}</td>
                              </tr>
                            </table>
                          </div>
                          </span>
                        </td>
                      </tr>
                    </template>
                  </table>
                </div>
              </span>
            </template>
          </b-table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="save" :disabled="isSaveDisable(selectedItem,selectedItemDetail)">決定</button>
        <button class="button" type="button" @click="$parent.close()">閉じる</button>
      </footer>
    </div>
    <!-- 標準品目選択モーダル -->
    <b-modal :active.sync="standardItemSelectModalZctive" has-modal-card full-screen :can-cancel="false">
      <template>
        <!-- 見積選択 -->
        <div id="standardItemSelectModal" style="width: 95%;height:95%;margin-left: 2%;margin-top: 1%;">
          <div class="modal-card" style="width: 100%;height:100%;">
            <header class="modal-card-head">
              <p class="modal-card-title" style="color: whitesmoke;">{{standardItemCode}}品目選択</p>
            </header>
            <section class="modal-card-body">
              <div class="condition-area">
                <table class="conditionTable">
                  <tr>
                    <th>品目コード</th>
                    <td>
                      <input type="text" id="standardItemFilter" v-model="standardItemCodeFilterStr" @input="standardItemFilterChange"/>
                    </td>
                    <th>品目名</th>
                    <td>
                      <input type="text" id="standardItemFilter" v-model="standardItemNameFilterStr" @input="standardItemFilterChange"/>
                    </td>
                    <td colspan="4"></td>
                  </tr>
                </table>
              </div>
              <div class="result-area">
                <b-button class="is-primary" style="float: left;" @click="ShowDetail4Standard">申込み内容参照</b-button>
                <floatingModal name="Detail4Standard-modal" modalClass="Detail4Standard-modal" @close="closeRequestDetail4Standard" title="案件詳細" topFixed="false" width="900" height="480" right="100px">
                  <cpapRequestDetail :data="showDetailTargetData" :innerUser="true" :directionsItem="directionsItemList" :isResume="isResume"/>
                </floatingModal>
                <b-table
                  v-if="standardItems.length>0"
                  id="standardItemSelectTable"
                  :data="filteredStandardItems"
                  paginated
                  per-page="20"
                  pagination-position="both"
                  aria-next-label="Next page"
                  aria-previous-label="Previous page"
                  aria-page-label="Page"
                  aria-current-label="Current page"
                >
                  <template slot-scope="props">
                    <b-table-column field="customerId" label="" width="20" centered>
                      <b-checkbox v-model="selectedStandardItems" :native-value="props.row"></b-checkbox>
                    </b-table-column>
                    <b-table-column :searchable="true" field="itemCode" label="品目コード" width="100" sortable>{{props.row.itemCode}}</b-table-column>
                    <b-table-column field="itemName" label="品目名" width="250" sortable>{{props.row.itemName}}</b-table-column>
                  </template>
                </b-table>
              </div>
            </section>
            <footer class="modal-card-foot">
              <button class="button" type="button" @click="selectItems(selectedStandardItems)" :disabled="selectedStandardItems.length==0">決定</button>
              <button class="button" type="button" @click="standardModalClose()">閉じる</button>
            </footer>
          </div>
        </div>
      </template>
    </b-modal>
    <floatingModal name="Detail4Quotation-modal" modalClass="Detail4Quotation-modal" @close="closeRequestDetail4Quotation" title="案件詳細" topFixed="false" width="900" height="480" right="100px">
      <cpapRequestDetail :data="showDetailTargetData" :innerUser="true" :directionsItem="directionsItemList" :isResume="isResume"/>
    </floatingModal>
  </div>
</template>
<script>
import floatingModal from "@/components/mock/common/FloatingModal";
import CpapRequestDetail from "@/components/mock/common/CpapRequestDetail";
const debounce = (func, wait = 1000) => {
  let timerId;
  return function(...args){
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
};
export default {
  name: "QuotationBulkSelectModal",
  props: {
    title:{default:"見積一括選択"},
    hospital: {default: ""},
    selectItemModel: {default: ""},
    showDetailTargetData:{default:() => ({})},
    directionsItems:{default:() => ([])},
    resume: {default: false},
    topMsg: {default: ""},
    belongs: {default: ""},
    institutionId: {default: ""}
  },
  methods: {
    standardModalClose: function(){
      this.selectedStandardItems = []
      this.standardItems = ""
      this.filteredStandardItems = ""
      this.standardItemCodeFilterStr = "",
      this.standardItemNameFilterStr = "",
      this.targetNumber = ""
      this.targetDetailsNumber = ""
      this.targetIndex = ""
      this.standardItemSelectModalZctive = false
    },
    standardItemSelect: function(itemCode, standardItems, quotationNumber, quotationDetailsNumber, index){
      this.standardItemCode = itemCode
      this.standardItems = standardItems
      this.filteredStandardItems = standardItems
      this.targetNumber = quotationNumber
      this.targetDetailsNumber = quotationDetailsNumber
      this.targetIndex = index
      this.standardItemSelectModalZctive = true
    },
    selectItems: function(selects){
      var index,quotationDetailsNumber
      for(let rowData of this.data){
        if(rowData.quotationNumber!=this.targetNumber) continue
        for(let item of rowData.items){
          if(item.quotationDetailsNumber!=this.targetDetailsNumber) continue
          item.selectItems = selects
          index = rowData.index
          quotationDetailsNumber = item.quotationDetailsNumber
        }
      }
      for(let sel of selects){
        this.selectedStandardItemDetail.push(index+','+quotationDetailsNumber+','+sel.itemCode)
      }
      console.log(index+','+quotationDetailsNumber)
      this.selectedItemDetail.push(index+','+quotationDetailsNumber)

      this.selectedStandardItems = []
      this.standardItems = ""
      this.targetNumber = ""
      this.targetDetailsNumber = ""
      this.targetIndex = ""
      this.standardItemSelectModalZctive = false
      // 再レンダリングの為、フラグ切替
      this.renderKey = !this.renderKey
    },
    standardItemFilterChange: debounce(function() {
            let _this = this
            this.filteredStandardItems = this.standardItems.filter(element => {
                
                return String(element.itemCode).includes(_this.standardItemCodeFilterStr) && String(element.itemName).includes(_this.standardItemNameFilterStr); 

            });
    }, 500),
    changeStandardItem: function(targetNumber,setNumber) {
      var standard = this.selectedStandardItemDetail.find(val => {return (val.split(',')[1]) == targetNumber })
      // var standard = this.selectedStandardItemDetail.find(val => val.indexOf(targetNumber)!=-1 )
      if(!standard){
        // 1件も存在しなくなった場合
        this.selectedItemDetail = this.selectedItemDetail.filter(val => val != setNumber)
      }else{
        // 1件以上存在する場合
        var target = this.selectedItemDetail.find((val) =>{return val == setNumber})
        if(!target){
          // 標準品目コードが選択されていない場合
          this.selectedItemDetail.push(setNumber)
        }
      }
    },
    returnFalse: function() {
      return false
    },
    selecteRadio: function(rowData) {
      this.detailOpenList = [rowData]
    },
    isSaveDisable: function(item,detailList) {
      if(!item || detailList.length==0){
        return true
      }
      for(var detail of detailList){
        var list = detail.split(',')
        if(item.index == list[0]){
          return false
        }
      }
      return true
    },
    save: function() {
      var rtnObj = {}
      rtnObj = JSON.parse(JSON.stringify(this.selectedItem));
      rtnObj.items = []
      // 選択されている見積もり詳細
      for(var detail of this.selectedItemDetail){
        var list = detail.split(',')
        // 見積詳細情報格納（見積番号をまたいで格納できるようにする）
        for(let rowData of this.data){
          if(rowData.items && rowData.items.length>0){
            rowData.items.find(item => {
              if(rowData.index == list[0] && item.quotationDetailsNumber == list[1]){
                if(item.standardItems && item.standardItems.length > 0){
                  // 標準品目の場合
                  for(let standard of item.standardItems){
                    var number = rowData.index+','+item.quotationDetailsNumber+','+standard.itemCode
                    var target = this.selectedStandardItemDetail.find(val => {return val == number})
                    if(target) {
                      rtnObj.items.push({
                        itemCode:standard.itemCode,
                        itemName:standard.itemName,
                        quotationDetailsNumber: item.quotationDetailsNumber,
                        quantity: item.quantity,
                        unit: item.unit,
                        deliveryPrice: item.deliveryPrice,
                        unitPrice: item.unitPrice,
                        quotationPrice: item.quotationPrice,
                        comment: item.comment,
                        latestOrderRegisteredDate: item.latestOrderRegisteredDate,
                        estimateCode: rowData.quotationNumber,
                        billingDestinationCode:rowData.billingDestinationCode,
                        hospitalCode:rowData.hospitalCode
                      })
                    }
                  }
                }else{
                  // 標準品目で無い場合
                  item.estimateCode = rowData.quotationNumber
                  item.billingDestinationCode = rowData.billingDestinationCode
                  item.hospitalCode = rowData.hospitalCode
                  rtnObj.items.push(item)
                }
              }
            })
          }
        }
      }
      // 品目コード重複の場合はエラー
      for(let item of rtnObj.items){
        let target = rtnObj.items.filter(val => val.itemCode == item.itemCode)
        if(target.length > 1){
          this.showErrorMessage("同一の品目コードが選択されています。")
          return
        }
      }
      this.$emit('select', rtnObj);
      this.$parent.close();
    },
    doSearch: function() {
      this.selectedItem = '';
      this.selectedItemDetail = [];
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalCpap.getEstimateCodeListPOST({
            body:{
              itemName: "",
              model: "",
              hospitalCode:_this.hospitalCode,
              belongsId: _this.belongsId,
              institutionId: _this.institutionId
            }
          });
        },
        async function(result){
          if(result.obj.length < 1){
            _this.showMessage('該当する見積情報は存在しません。');
          }
          _this.data = result.obj;
          // 検索結果を見積番号降順に並べ替え
          _this.data.sort(function(a, b) {
            if (a.quotationNumber < b.quotationNumber) {
              return 1;
            } else {
              if(a.quotationNumber == null){
                return 1;
              }
              return -1;
            }
          })

          // 初期表示
          if(_this.data){
            //見積検索チェックボックスにチェックが入っているもの
            let targetList = _this.filteredDirectionsItemList.filter(val => val.isChecked == true);
            if(targetList){
              for(var target of targetList){
                let targetItemCode = target.itemCode
                let targetItemName = target.name
                for(var data of _this.data){
                  //初期表示対象見積検索
                  // 品目コードで検索
                  let targetItem = data.items.filter(val => val.itemCode == targetItemCode);
                  if(targetItem.length == 0){
                    // ヒットしない場合標準品目の中を検索
                    if(data.items.length > 0){
                      for(var item of data.items){
                        if(item.standardItems && item.standardItems.length > 0){
                          let targetStandardItem = item.standardItems.filter(val => val.itemCode == targetItemCode);
                          if(targetStandardItem && targetStandardItem.length > 0){
                            targetItem = data.items.filter(val => val.itemCode == item.itemCode)
                            break
                          }
                        }
                      }
                    }
                  }
                  if(targetItem && targetItem.length > 0){
                    let item = targetItem[0]
                    //標準品目の場合
                    if(item.standardItems && item.standardItems.length > 0){
                      var selectedStandardItem=
                      [{
                        "itemCode": targetItemCode,
                        "itemName": targetItemName
                      }]
                      _this.targetNumber = data.quotationNumber
                      _this.targetDetailsNumber = item.quotationDetailsNumber
                      _this.standardItemCode = data.itemCode
                      _this.standardItems = data.standardItems
                      _this.filteredStandardItems = data.standardItems
                      _this.targetIndex = data.index

                      _this.selectItems(selectedStandardItem)
                      break;
                    }else{
                      _this.selectedItemDetail.push(data.index+','+item.quotationDetailsNumber)
                      _this.selectedStandardItems = []
                      _this.standardItems = ""
                      _this.targetNumber = ""
                      _this.targetDetailsNumber = ""
                      _this.targetIndex = ""
                      break;
                    }
                  }
                }
              }
            }
            // 「選択中の品目あり」が表示された見積をすべて展開する。
            let showDetailList = [];
            for (let i = 0; i < _this.data.length; i++) {
              if (_this.isSelected(_this.data[i].index)) {
                if (!_this.selectedItem) {
                  _this.selectedItem = _this.data[i]
                }
                showDetailList.push(_this.data[i])
              }
            }
            _this.detailOpenList = showDetailList
          }

        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    ShowDetail4Quotation: function() {
      this.$modal.show('Detail4Quotation-modal')
    },
    closeRequestDetail4Quotation: function() {
      this.$modal.hide('Detail4Quotation-modal')
    },
    ShowDetail4Standard: function() {
      this.$modal.show('Detail4Standard-modal')
    },
    closeRequestDetail4Standard: function() {
      this.$modal.hide('Detail4Standard-modal')
    },
    isA: function() {
        return "isChecked"
    },
    isSelected: function(index) {
      for(var detail of this.selectedStandardItemDetail){
        var list = detail.split(',')
        if(index == list[0]){
          return true
        }
      }
      for(var detail of this.selectedItemDetail){
        var list = detail.split(',')
        if(index == list[0]){
          return true
        }
      }
        return false
    },
    changeDate: function(date) {
      // 文字列をYYYY/MM/ddの文字列形式に変換
      var changeDate =date
      if(date != null && date !=""){
        date = date.slice( 0, 10);
        var y = date.split("-")[0];
        var m = date.split("-")[1];
        var d = date.split("-")[2];
        changeDate = (y + "/" + m + "/" + d)
      }
      return changeDate
    },
  },
  data() {
    // 処方再開(転院)判定
    var isResume = false;
    if(this.resume){
      isResume = this.resume;
    }
    let modelList = this.getCpapMaster();
    let filteredDirectionsItemList = this.directionsItems.filter(element => element.shippingInstructionsFlg == true);
    filteredDirectionsItemList.forEach(item =>{
      item.isChecked = true;
    })
    return {
      itemName:"",
      model:this.selectItemModel,
      hospitalCode:this.hospital,
      data: [],
      modelList,
      selectedItem: '',
      selectedItemDetail: [],
      detailOpenList:[],
      standardItemCodeFilterStr:"",
      standardItemNameFilterStr:"",
      filteredStandardItems: [],
      standardItems:[],
      standardItemCode:"",
      targetNumber:"",
      targetDetailsNumber:"",
      targetIndex:"",
      standardItemSelectModalZctive:false,
      selectedStandardItems:[],
      selectedStandardItemDetail:[],
      renderKey:true,
      directionsItemList:this.directionsItems,
      isResume,
      belongsId: this.belongs,
      institutionId: this.institutionId,
      filteredDirectionsItemList: filteredDirectionsItemList
    };
  },
  filters: {},
  components: {
    floatingModal: floatingModal,
    cpapRequestDetail:CpapRequestDetail
  },
  async mounted() {}
};
</script>
<style lang="scss" scoped>
.conditionTable th {
  width: 100px;
}
.conditionTable td {
  width: 400px;
}
a {
  text-decoration: underline;
}
.tag {
  width: 100px;
}
.customRadio {
  width:10px;
}
.result-area {
  height: 450px;
}
.innerTable {
  width: 100% !important;
}
</style>
<style lang="scss">
.quotation-select-table-top-header th {
  background-color:#D9D9D9 !important;
  color:#000000;
}
.quotation-select-btable-header.b-table th {
  background-color:#93BDF9;
  color:#000000;
}
.quotation-select-table-detail-header td {
  background-color:#DFEBFD;
  color:#000000;
  font-size: 12px;
}
.quotation-select-table-standard-detail td {
  background-color:#DFEBFD;
  color:#000000;
}
.quotation-select-btable-header.b-table th > div {
  font-weight: bold;
}
.quotation-select-btable-header.b-table .table tr.detail .detail-container {
  padding: 1rem 0 1rem 4rem;
}

</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/QuotationBulkSelectModal.vue